module.exports = __webpack_public_path__ + "static/media/pingan-logo@2x.43ae40ba.png";